import { ICapacity } from "Agile/Scripts/SprintsHub/Capacity/CapacityContracts";
import { IAggregatedCapacity, ISprintCapacityOptions } from "Agile/Scripts/SprintsHub/Common/SprintCapacityDataProvider";

/** Loading status */
export const enum LoadingStatus {
    None = 0,
    Loading = 1,
    ErrorLoadingData = 2,
    LoadedNoContent = 3,
    LoadedWithContent = 4
}

/**
 * Defines capacity data generated by the Sprints hub pivots and consumed by the work details pane rendered
 * by the SprintViewRightPanel.
 */
export interface ISprintCapacityData {
    aggregatedCapacity: IAggregatedCapacity;
    capacityOptions: ISprintCapacityOptions;
    teamCapacity: ICapacity;
}
